import React from "react";
import "./CheckEligibilityBanner.css";
import { Button, useMediaQuery } from "@mui/material";

const CheckEligibilityBanner = () => {
  const isMediumScreen = useMediaQuery(" (max-width:768px) ");
  const isSmallScreen = useMediaQuery(" (max-width:576px) ");
  const isExtraSamallScreen = useMediaQuery("(max-width:400px)");
  return (
    <>
      <div
        className="increase-margines"
        style={{
          backgroundColor: "#E7E4F9",
          borderRadius: 5,
          padding: isSmallScreen ? 30 : 40,
          marginTop: "2%",
          marginBottom: "2%",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 8,
            backgroundColor: "transparent",
          }}
        >
          <p
            className="minutes"
            style={{
              color: "#59266D",
              backgroundColor: "transparent",
              fontFamily: "Archivo",
              fontSize: isMediumScreen ? 28 : 32,
              fontWeight: 600,
            }}
          >
            Take Charge of Your Finances
          </p>
          <p
            style={{
              color: "#59266D",
              backgroundColor: "transparent",
              fontFamily: "Archivo",
              fontSize: isSmallScreen ? 16 : 18,
              fontWeight: 400,
              lineHeight: 1.2,
            }}
          >
            Using Minemi’s Home Loan Eligibility Calculator is just the first
            step in your homeownership journey. With clear insights and
            actionable recommendations, you’re now better equipped to make
            informed decisions. Start comparing lenders, optimize your financial
            profile, and turn your dream of owning a home into reality.
          </p>
          <p
            style={{
              color: "#59266D",
              backgroundColor: "transparent",
              fontFamily: "Archivo",
              fontSize: isSmallScreen ? 16 : 18,
              fontWeight: 400,
              lineHeight: 1.2,
            }}
          >
            Let Minemi be your partner in simplifying home loan eligibility
            —helping you make smarter, faster, and better financial choices.
          </p>
          <div className=" ">
            <Button
              sx={{
                backgroundColor: "#553285",
                color: "white",
                borderRadius: 3,
                padding: isExtraSamallScreen ? "10px 20px" : "10px 45px",
                fontFamily: "Archivo",
                fontWeight: 500,
                fontSize: isSmallScreen ? 16 : 18,
                textTransform: "none",
              }}
              onClick={() => {
                window.location.href =
                  "https://minemi.ai/home-loan/check-eligibility";
              }}
            >
               Check Your Eligibility Now
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default CheckEligibilityBanner;
